import * as Lambda from './LambdaApi';

const createMessageRecipient = async (
    firstName,
    lastName,
    contact,
    exercise,
    rx,
    greetingContactOverride,
    password,
    isResponseEnabled,
) => {
    const apiPath = `/residents`;
    return Lambda.Post(
        apiPath,
        {
            firstName,
            lastName,
            contact,
            exercise: exercise || null,
            rx: rx || null,
            greetingContactOverride: greetingContactOverride || null,
            password,
            isResponseEnabled,
        },
        'lambda',
    );
};

const getMessageRecipientDetails = async (residentId) => {
    try {
        let params = {};
        const apiPath = `/residents/${residentId}`;

        const getMessageResponse = await Lambda.Get(apiPath, params, 'lambda');
        if (!getMessageResponse.success) return false;
        return getMessageResponse.resident;
    } catch (error) {
        return false;
    }
};

const putMessageRecipientDetails = async (formData) => {
    try {
        let params = {};
        const apiPath = `/residents/${formData._id}`;
        const payloadObject = {
            firstName: formData.FirstName,
            lastName: formData.LastName,
            exercise: formData.Exercise || null,
            rx: formData.Rx || null,
            greetingContactOverride: formData.GreetingContactOverride || null,
        };

        const updateResponse = await Lambda.Put(apiPath, payloadObject, 'lambda');
        if (!updateResponse.success) return false;
        return updateResponse;
    } catch (error) {
        return false;
    }
};

const putMessageRecipientImage = async (image, _id) => {
    try {
        let params = {};
        const apiPath = `/residents/${_id}`;
        const payloadObject = {
            profileImage: image,
        };
        const updateResponse = await Lambda.Put(apiPath, payloadObject, 'lambda');
        if (!updateResponse.success) return false;
        return updateResponse;
    } catch (error) {
        return false;
    }
};

const updateIsResponseEnabled = async (checked, _id) => {
    try {
        const apiPath = `/residents/${_id}`;
        const payloadObject = {
            isResponseEnabled: checked,
        };

        const updateResponse = await Lambda.Put(apiPath, payloadObject, 'lambda');

        if (!updateResponse.success) return false;

        return updateResponse;
    } catch (err) {
        return false;
    }
};

const changeMessageRecipientPassword = async (residentId, password) => {
    try {
        const apiPath = `/residents/${residentId}/password`;
        const payloadObject = {
            password,
        };

        const updateResponse = await Lambda.Post(apiPath, payloadObject, 'lambda');

        if (!updateResponse.success) return false;

        return true;
    } catch (error) {
        return false;
    }
};

const residentInvite = async (alexaUserInvite) => {
    const apiPath = `/residents/invites`;
    const payloadObject = alexaUserInvite;

    const updateResponse = await Lambda.Post(apiPath, payloadObject, 'lambda');

    if (!updateResponse.success) {
        return Promise.reject();
    }

    return true;
}


const listResidentInvites = async () => {
    const apiPath = `/residents/invites`;
    const response = await Lambda.Get(apiPath,{}, 'lambda');

    if (!response.success) {
        return Promise.reject();
    }

    return response.invitations
}


const deleteResidentInvites = async (invitationId) => {
    const apiPath = `/residents/invites/${invitationId}`;
    const response = await Lambda.Delete(apiPath, {}, 'lambda');
    if (!response.success) {
        return false;
    }

    return true;
}

const getResidentInvitationByToken = async token => {
    const apiPath = `/residents/invites/public/${token}`;
    const response = await Lambda.Get(apiPath, {}, 'lambda');

    if (!response.success) {
        return Promise.reject();
    }

    return response.invitation;
}

const getResidentAddressBookContacts = async (residentId,token='') => {
    const apiPath = `/residents/${residentId}/address-book/contacts`;
    const response = await Lambda.Get(apiPath, {paginationToken: token}, 'lambda');

    if (!response.success) {
        return Promise.reject();
    }
    console.log(response.contacts)
    return response.contacts;
}

const createAddressBookContact = async (residentId, contactName, contactNumbers) => {
    const apiPath = `/residents/${residentId}/address-book/contacts`;

    const response = await Lambda.Post(apiPath, {
        contactName, 
        contactNumbers
    }, 'lambda');

    if (!response.success) {
        return Promise.reject();
    }

    console.log(response);
    const { contact } = response;
    return contact;
}


const enableInboundCalling = async (residentId, contactId) => {
    const apiPath=`/residents/${residentId}/address-book/contacts/${contactId}/inbound`;

    const responseD = await Lambda.Post(apiPath, {}, 'lambda');

    if (!responseD.success) {
        return Promise.reject();
    }

    console.log(responseD);
    const { response } = responseD;
    return response;
}

const getContactDetails = async (residentId, contactId) => {
    const apiPath=`/residents/${residentId}/address-book/contacts/${contactId}`;

    const response = await Lambda.Get(apiPath, {}, 'lambda');

    if (!response.success) {
        return Promise.reject();
    }

    const { contact } = response;
    return contact;    
}


const deleteContact = async(residentId, contactId) => {
    const apiPath = `/residents/${residentId}/address-book/contacts/${contactId}`;

    const response = await Lambda.Delete(apiPath, {}, 'lambda');

    if (!response.success) {
        return Promise.reject();
    }

    const { contact } = response;
    return contact;    
    
}


const listResidentDevices = async (residentId) => {
    const apiPath=`/residents/${residentId}/unit-endpoints`

    const response = await Lambda.Get(apiPath, {}, 'lambda');

    if (!response.success) {
        return Promise.reject();
    }

    const { endpoints } = response;
    return endpoints;   
}


const changeDeviceFriendlyName = async (residentId, endpointId, friendlyName) =>{
    const apiPath=`/residents/${residentId}/unit-endpoints/${endpointId}`;

    const response = await Lambda.Post(apiPath, {
        friendlyName
    }, 'lambda');

    if (!response.success) {
        return Promise.reject();
    }

    console.log('response: ', response);
    return response;
}


const updateA4HContactName = async (residentId, relativeId, contactName) => {
    const apiPath = `/residents/${residentId}/relatives/${relativeId}/address-book-contact-name`;

    const response = await Lambda.Put(apiPath, {
        contactName
    } , 'lambda');

    console.log (response);

    if (!response.success) {
        return Promise.reject();
    }

    return response;
}

export {
    createMessageRecipient,
    getMessageRecipientDetails,
    putMessageRecipientDetails,
    putMessageRecipientImage,
    changeMessageRecipientPassword,
    updateIsResponseEnabled,
    residentInvite, 
    listResidentInvites, 
    deleteResidentInvites, 
    getResidentInvitationByToken,
    getResidentAddressBookContacts,
    createAddressBookContact,
    enableInboundCalling,
    getContactDetails,
    deleteContact, 
    listResidentDevices,
    changeDeviceFriendlyName, 
    updateA4HContactName
};
